<script>
export default {
    name: "buy",
    data() {
        return {
            list: [
                { name: '月度会员', price: '38.00' },
                { name: '季度会员', price: '68.00' },
                { name: '年度会员', price: '128.00' },
            ],
            activeIndex: null,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="buy layout_main">
        <div class="top">
            <p class="desc">无需提前预订。出示会员卡，即可参观您心仪的展览，即使门票已售罄</p>
        </div>
        <div class="wrapper flex flex_column">
            <div>
                <p class="title">Ambassador<sup>+</sup>会员</p>
                <p class="desc">三次即可收回会员费！</p>
            </div>
            <div class="list flex flex_column">
                <div class="item flex flex_column justify_between" :class="{active: activeIndex == index}" v-for="(item, index) in list" :key="index" @click="activeIndex = index">
                    <p class="name">{{ item.name }}</p>
                    <p class="price" v-if="item.price == '0.00'">免费</p>
                    <p class="price" v-else>RMB {{ item.price }}</p>
                </div>
            </div>
            <div class="btn layout_flex_center">加入购物袋</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.buy{
    width: 7.4rem;
    padding: .35rem 0;
    @media only screen and (max-width: 750px) {
        width: 100%;
    }
}
.top{
    margin-bottom: .3rem;
    .title{
        font-size: .26rem;
        text-align: center;
    }
    .desc{
        text-align: center;
        font-size: .18rem;
    }
    @media only screen and (max-width: 750px) {
        .title{
            font-weight: bold;
        }
        .desc{
            font-size: .2rem;
        }
    }
}
.wrapper{
    border: 1px solid #666;
    padding: .3rem;
    gap: .3rem;
    @media only screen and (max-width: 750px) {
        border: none;
    }
    .title{
        font-size: .2rem;
    }
    .desc{
        font-size: .18rem;
    }
    .list{
        gap: .3rem;
        .item{
            padding: .2rem;
            height: 1.6rem;
            border: 1px solid #666;
            font-size: .2rem;
            cursor: pointer;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
            &.active{
                background: #333;
                border-color: #333;
                color: #fff;
                .price{
                    color: #fff;
                }
            }
            .price{
                text-align: right;
                color: #666;
            }
        }
    }
    .btn{
        height: .75rem;
        font-size: .2rem;
        color: #666;
        border: 1px solid #666;
        cursor: pointer;
        @media only screen and (max-width: 750px) {
            height: .8rem;
            font-size: .26rem;
        }
    }
}
</style>